<template>
  <t-default-layout active-nav-id="home-sub-banner">
    <div :class="componentClassName">
      <a-back-page text="一覧画面" page="HomeSubBanner" />
      <form
        ref="form"
        class="t-home-sub-banner-add__form"
        enctype="multipart/form-data"
        @submit.prevent="handleFormSubmit"
      >
        <div class="t-home-sub-banner-add__fields">
          <m-section>
            <div class="t-home-sub-banner-add__tabgroup">
              <ul class="t-home-sub-banner-add__tabnav">
                <li
                  data-testid="t-home-sub-banner-display-button-new"
                  :class="{ selected: activeTab === 'new' }"
                  @click="activeTab = 'new'"
                >
                  リニューアル後（新小バナー）
                </li>
                <li
                  data-testid="t-home-sub-banner-display-button-old"
                  :class="{ selected: activeTab === 'old' }"
                  @click="activeTab = 'old'"
                >
                  リニューアル前（旧小バナー）
                </li>
              </ul>

            <!-- 詳細設定（新旧統合） -->
            <m-action-card
              :id=idName[1]
              title="詳細設定"
              header-border
              no-header-margin
              icon="clock"
            >
              <!-- 共通：フラグ設定エリア -->
              <div class="t-home-sub-banner-add__row1">
                <m-form-input
                  id="t-home-sub-banner-add-dAccountLoginFlag__form-input"
                  class="t-home-sub-banner-add__flag-row"
                >
                  <a-text
                    id="t-home-sub-banner-add-dAccountLoginFlag__a-text"
                    class="t-home-sub-banner-add__label-with-indent"
                    weight="bold"
                    >ビジネスｄアカウントログイン</a-text
                  >
                  <a-switch
                    id="t-home-sub-banner-add-dAccountLoginFlag"
                    v-model="homeSubBannerData.dAccountLoginFlag"
                    class="t-home-sub-banner-add__switch-label"
                    data-testid="add-news-and-seminar-priority-toggle-button"
                  />
                </m-form-input>
              </div>
              <div class="t-home-sub-banner-add__row1">
                <m-form-input
                  id="t-home-sub-banner-add-webviewFlag__form-input"
                  class="t-home-sub-banner-add__flag-row"
                >
                  <a-text
                    id="t-home-sub-banner-add-webviewFlag__a-text"
                    class="t-home-sub-banner-add__label-with-indent"
                    weight="bold"
                    >Webビュー</a-text
                  >
                  <a-switch
                    id="t-home-sub-banner-add-webviewFlag"
                    v-model="homeSubBannerData.webviewFlag"
                    class="t-home-sub-banner-add__switch-label"
                    data-testid="add-news-and-seminar-priority-toggle-button"
                  />
                </m-form-input>
              </div>
              <div class="t-home-sub-banner-add__row1">
                <m-form-input
                  id="t-home-sub-banner-add-notificationPromptFlag__form-input"
                  class="t-home-sub-banner-add__flag-row">
                  <a-text
                  id="t-home-sub-banner-add-notificationPromptFlag__a-text"
                  class="t-home-sub-banner-add__label-with-indent"
                  data-testid="add-home-sub-banner-notificationPromptFlag-text"
                  weight="bold"
                  >通知許可フラグ</a-text
                >
                  <div class="t-home-sub-banner-add__flag-control">
                    <a-switch
                      id="t-home-sub-banner-add-notificationPromptFlag"
                      v-model="homeSubBannerData.notificationPromptFlag"
                      class="t-home-sub-banner-add__switch-label"
                      data-testid="add-home-sub-banner-notification-toggle-button"
                    />
                    <a-text 
                      id="t-home-sub-banner-add-notificationPromptFlag__a-text-notice" 
                      class="t-home-sub-banner-add__flag-control__notice" 
                      data-testid="add-home-sub-banner-notificationPromptFlag-sub-text"
                      >※プッシュ通知未許可ユーザーにポップアップを表示します</a-text
                    >
                  </div>
                </m-form-input>
              </div>

              <!-- 差分：画像・テキスト入力エリア -->
              <div class="t-home-sub-banner-add__fields">
                <div
                  v-show="activeTab === 'new'"
                  id="t-home-sub-banner-add-uploading-file-new"
                  class="t-home-sub-banner-add__row t-home-sub-banner-add__image-upload-area
                  t-home-sub-banner-add__row--square">
                  <!-- リニューアル後のレイアウト -->
                  <div class="t-home-sub-banner-add__col-1">
                    <m-form-input>
                      <a-upload-field
                          id="upload-image-new"
                          v-model="homeSubBannerData.newImageFile.file"
                          test-id-text="add-home-sub-banner-image-new"
                          name="imageFile"
                          class="t-home-sub-banner-add-uploading-file__form-upload"
                          label="ファイルをドラッグ＆ドロップするかパソコンからファイルを貼り付けしてください。"
                          accept="image/png, image/jpg, image/jpeg"
                          @change="handleUploadFileChange('newImageFile', $event)"
                          @show-error-modal="showErrorModal"
                      />
                    </m-form-input>
                  </div>
                  <div class="t-home-sub-banner-add__col-2">
                    <a-text class="t-home-sub-banner-add__text-field-label" weight="bold">タイトル</a-text>
                      <m-form-input>
                        <a-apply-text-field
                          id="title-new"
                          v-model="homeSubBannerData.newTitle"
                          data-testid="add-home-sub-banner-title-input-new"
                          type="text"
                          maxlength="19"
                          maxlength-id="t-home-sub-banner-add-title-maxlength-new"
                          placeholder="タイトル入力"
                        />
                      </m-form-input>
                      <a-text class="t-home-sub-banner-add__text-field-label" weight="bold">補足説明</a-text>
                      <m-form-input>
                        <a-apply-text-field
                          id="description"
                          v-model="homeSubBannerData.newDescription"
                          data-testid="add-home-sub-banner-description-input"
                          type="text"
                          maxlength="22"
                          maxlength-id="t-home-sub-banner-add-description-maxlength"
                          placeholder="説明文入力"
                        />
                      </m-form-input>
                      <a-text class="t-home-sub-banner-add__text-field-label" weight="bold">タグ設定</a-text>
                      <div class="t-home-sub-banner-add__tag-list">
                        <div
                          v-for="(tag, index) in homeSubBannerData.newTags"
                          :key="index"
                          class="t-home-sub-banner-add__tag-item"
                        >
                          <m-form-input>
                            <a-apply-text-field
                              :id="'tag-' + index"
                              v-model="homeSubBannerData.newTags[index]"
                              :data-testid="'add-home-sub-banner-tag-input-new-' + index"
                              type="text"
                              maxlength="10"
                              :placeholder="'タグ' + (index + 1)"
                            />
                          </m-form-input>
                        </div>
                      </div>
                  </div>
                </div>
                <div v-show="activeTab === 'old'" id="t-home-sub-banner-add-uploading-file" class="t-home-sub-banner-add__row">
                  <!-- リニューアル前のレイアウト -->
                  <div class="t-home-sub-banner-add__col-1">
                    <m-form-input>
                      <a-upload-field
                        id="upload-image"
                        v-model="homeSubBannerData.imageFile.file"
                        test-id-text="add-home-sub-banner-image"
                        name="imageFile"
                        class="t-home-sub-banner-add-uploading-file__form-upload"
                        label="ファイルをドラッグ＆ドロップするかパソコンからファイルを貼り付けしてください。"
                        accept="image/png, image/jpg, image/jpeg"
                        @change="handleUploadFileChange('imageFile', $event)"
                        @show-error-modal="showErrorModal"
                      />
                    </m-form-input>
                  </div>
                  <div class="t-home-sub-banner-add__col-2">
                    <div class="t-home-sub-banner-add__fields">
                      <m-form-input>
                        <a-apply-text-field
                          id="title"
                          v-model="homeSubBannerData.title"
                          data-testid="add-home-sub-banner-title-input"
                          type="text"
                          maxlength="30"
                          maxlength-id="t-home-sub-banner-add-title-maxlength"
                          placeholder="バナー名称入力"
                        />
                      </m-form-input>
                    </div>
                  </div>
                </div>

                <!-- 共通：URL入力エリア -->
                <div class="t-home-sub-banner-add__row">
                  <a-text id="t-home-sub-banner-add-iOSWebsite__a-text">
                    ios側Webサイト&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</a-text
                  >
                  <m-form-input>
                    <a-apply-text-field
                      id="t-home-sub-banner-add-iOS__contents-url"
                      v-model="homeSubBannerData.iosContentsURL"
                      class="t-home-sub-banner-add__contents-url"
                      :disabled="disabled"
                      data-testid="t-home-sub-banner-add-url-input"
                      type="text"
                      maxlength="500"
                      maxlength-id="t-home-sub-banner-add-iOS__contents-url-maxlength"
                      placeholder="iOS側のURL入力"
                    />
                  </m-form-input>
                </div>
                <div class="t-home-sub-banner-add__row">
                  <a-text id="t-home-sub-banner-add-androidWebsite__a-text"> android側Webサイト</a-text>
                  <m-form-input>
                    <a-apply-text-field
                      id="t-home-sub-banner-add-android__contents-url"
                      v-model="homeSubBannerData.androidContentsURL"
                      class="t-home-sub-banner-add__contents-url"
                      :disabled="disabled"
                      data-testid="t-home-sub-banner-add-url-input"
                      type="text"
                      maxlength="500"
                      maxlength-id="t-home-sub-banner-add-android__contents-url-maxlength"
                      placeholder="android側のURL入力"
                    />
                  </m-form-input>
                </div>
              </div>
            </m-action-card>
            </div>
          </m-section>
          <m-section>
            <m-action-card :id="idName[3]" title="公開設定" header-border no-header-margin icon="calendar-setting">
              <div class="t-home-sub-banner-add__fields">
                <div id="t-home-sub-banner-add-cast-start-date-day__row" class="t-home-sub-banner-add__row">
                  <a-text id="t-home-sub-banner-add-cast-start-date__a-text" weight="bold">公開日</a-text>　
                  <m-form-input id="t-home-sub-banner-add-cast-start-date-day__form-input">
                    <a-calendar-field
                      id="cast-start-date-day"
                      v-model="homeSubBannerData.castStartDate"
                      test-id-text="add-home-sub-banner-publish-start"
                      :min-date="minDate"
                      date-placeholder="公開日"
                      time-placeholder="00:00"
                      mode="dateTime"
                    />
                  </m-form-input>
                </div>
                <div class="t-home-sub-banner-add__row">
                  <a-text id="t-home-sub-banner-add-cast-end-date__a-text" weight="bold">公開終了日</a-text>　
                  <m-form-input id="t-home-sub-banner-add-cast-end-date-day__form-input">
                    <a-calendar-field
                      id="cast-end-date-day"
                      v-model="homeSubBannerData.castEndDate"
                      test-id-text="add-home-sub-banner-publish-end"
                      :min-date="minDate"
                      date-placeholder="公開終了日"
                      time-placeholder="00:00"
                      mode="dateTime"
                      @change="handleChange"
                    />
                  </m-form-input>
                </div>
              </div>
            </m-action-card>
          </m-section>
          <m-section>
            <m-action-card :id="idName[4]" title="承認フロー" header-border no-header-margin icon="user-setting">
              <div class="t-home-sub-banner-add__fields__pushtype">
                <m-form-input id="t-home-sub-banner-add__fields__pushtype">
                  <a-select-field
                    id="t-home-sub-banner-add__fields__pushtype__a-select-field"
                    v-model="homeSubBannerData.checkStatus"
                    data-testid="add-home-sub-banner-check-status-select"
                    :options="checkStatusOptions"
                    disabled="true"
                  />
                </m-form-input>
              </div>
            </m-action-card>
          </m-section>
        </div>
        <m-form-action-buttons>
          <a-button
            id="saveBtn"
            data-testid="add-home-sub-banner-save-button"
            variant="block"
            color="primary"
            :disabled="disabledButton"
            submit="submit"
            >保存</a-button
          >
        </m-form-action-buttons>
      </form>
    </div>
    <!-- Info, Erro Modal -->
    <teleport to="body">
      <o-modal
        id="online-shop-bannersCreate_resultModal"
        v-model:visible="resultModalVisible"
        class="o-modal--confirmation"
        footer-variant="confirmation"
        width="442px"
        :footer-shadow="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
      >
        <template #title>{{ resultModalTitle }}</template>
        <a-text>
          <!-- eslint-disable -->
          <span id="online-shop-bannersCreate_resultModal_body" v-html="resultModalContent" />
          <!-- eslint-enable -->
        </a-text>
        <template #footer>
          <a-button
            data-testid="error-info-modal-confirm-button"
            variant="block"
            color="primary"
            label="OK"
            size="small"
            @click="handleCloseModal"
          />
        </template>
      </o-modal>
    </teleport>
  </t-default-layout>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import AButton from '@/components/atoms/button';
import AUploadField from '@/components/atoms/upload-field';
import AText from '@/components/atoms/text';
import ABackPage from '@/components/atoms/back-page';
import AApplyTextField from '@/components/atoms/apply-text-field';
import MSection from '@/components/molecules/section';
import MActionCard from '@/components/molecules/action-card';
import MFormActionButtons from '@/components/molecules/form-action-buttons';
import TDefaultLayout from '@/components/templates/default-layout';
import { customRequest } from '@/common/customRequest.js';
import { messageContent } from '@/common/messageContent.js';
import { customValidate } from '@/common/customValidate.js';
import ACalendarField from '@/components/atoms/calendar-field';
import { utils } from '@/common/utils.js';
import { homeSubBannerValidation } from '@/validations/homeSubBanner.js';
import { useVuelidate } from '@vuelidate/core';
import { cloneDeep } from 'lodash';

export default {
  name: 't-home-sub-banner-add',
  components: {
    TDefaultLayout,
    MSection,
    MActionCard,
    AText,
    AButton,
    ABackPage,
    MFormActionButtons,
    AUploadField,
    ACalendarField,
    AApplyTextField,
  },
  mixins: [customRequest, customValidate, messageContent, utils],
  props: {
    class: {
      type: String,
      default: '',
    },
  },

  setup() {
    return {
      v$: useVuelidate(),
    };
  },

  data() {
    return {
      idName: [],
      minDate: utils.currentDateTime(),
      resultModalTitle: '',
      resultModalContent: '',
      resultModalVisible: false,
      activeTab: 'new',
      disabledButton: null,

      // コンテンツデータ
      homeSubBannerData: {
        title: '', // 旧タイトル用
        newTitle: '', // リニューアル後タイトル
        imageURL: '', // 画像の公開URL
        imageFile: {
          file: null,
          filename: null,
          binary: null,
          size: null,
        },
        newImageURL: '', // 新画像URL
        newImageFile: { // リニューアル後画像ファイルオブジェクト
          file: null,
          filename: null,
          binary: null,
          size: null,
        },
        newDescription: '', // 新説明文
        newTags: ['', '', '', '', ''], // 新タグ（5つ固定）
        position: 0, // 順序
        castStartDate: '', // 公開開始日
        castEndDate: '', // 公開終了日
        deleteDate: '', // 削除予定日
        draftFlag: true, // 下書き
        dAccountLoginFlag: false, //ビジネスｄアカウントログインフラグ
        webviewFlag: false, // Webビューフラグ
        notificationPromptFlag: false, // 通知許可フラグ
        checkStatus: 'draft', // 作成時のチェックステータスは下書き
        iosContentsURL: '', // iosコンテンツの遷移先URL
        androidContentsURL: '', // androidコンテンツの遷移先URL
      },
      checkStatusOptions: [
        { value: 'draft', label: '下書き' },
        { value: 'checked', label: 'チェック済み' },
        { value: 'approved', label: '承認済み' },
      ],
    };
  },

  validations() {
    return homeSubBannerValidation.create(this.homeSubBannerData.checkStatus);
  },

  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-home-sub-banner-add');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  created() {
    const authInfo = this.$store.state.user.authInfo;
    if (authInfo !== 'manager') {
      this.$router.push({ name: 'PermissionDenied' });
      return;
    }
    for (let i = 1; i <= 4; i++) {
      this.idName[i] = 'h1-home-sub-banner-add-' + i;
    }
  },
  methods: {
    async handleFormSubmit() {
      const isFormCorrect = await this.v$.$validate();

      if (!isFormCorrect) {
        let errMsg = '';
        this.v$.$errors.map(item => (errMsg += item.$message + '<br>'));
        this.showErrorModal(errMsg);
        return;
      }

      const payload = cloneDeep(this.homeSubBannerData);
      //  URLに特殊文字　<>'"　を入力するチェックする
      if (messageContent.checkUrlSpecialCharacter(payload.iosContentsURL)) {
        this.showErrorModal(messageContent.urlSpecialCharater);
        return;
      }
      if (messageContent.checkUrlSpecialCharacter(payload.androidContentsURL)) {
        this.showErrorModal(messageContent.urlSpecialCharater);
        return;
      }
      payload.androidContentsURL = encodeURI(payload.androidContentsURL);
      payload.iosContentsURL = encodeURI(payload.iosContentsURL);
      // Note: 「=」はCloudArmorポリシーに抵触するケースがあるためエスケープを行う
      // 新旧両方のデータをFirestoreに保存するため、両方のタイトルと新バナーのdescription/tagsをエスケープ
      payload.title = payload.title.replace(/=/g, '%%eq%%');
      payload.newTitle = payload.newTitle.replace(/=/g, '%%eq%%');
      payload.newDescription = payload.newDescription.replace(/=/g, '%%eq%%');
      // タグの空要素を完全に除外してからエスケープ処理を行う
      payload.newTags = payload.newTags
        .filter(tag => tag && tag.trim() !== '')
        .map(tag => tag.replace(/=/g, '%%eq%%'));

      if (!messageContent.checkHasSpecialCharacterInObj(payload)) {
        this.showErrorModal(messageContent.hasSpecialCharacter);
        return;
      }

      if (this.homeSubBannerData.castEndDate) {
        const castEndDate = new Date(this.homeSubBannerData.castEndDate);
        const deleteDate = new Date(castEndDate.setFullYear(castEndDate.getFullYear() + 1));
        this.deleteDate = this.convertDateToString(deleteDate);
      }
      const formDataTmp = {
        title: payload.title ?? '',
        newTitle: payload.newTitle ?? '',
        newDescription: payload.newDescription ?? '',
        newTags: payload.newTags ?? [],
        imageFile: this.homeSubBannerData.imageFile.binary ?? '', // 旧画像ファイル
        newImageFile: this.homeSubBannerData.newImageFile.binary ?? '', // 新画像ファイル
        position: this.homeSubBannerData.position ?? 0,
        castStartDate: this.homeSubBannerData.castStartDate ?? '',
        castEndDate: this.homeSubBannerData.castEndDate ?? '',
        deleteDate: this.deleteDate ?? '',
        draftFlag: this.homeSubBannerData.draftFlag ?? false,
        dAccountLoginFlag: this.homeSubBannerData.dAccountLoginFlag ?? false,
        webviewFlag: this.homeSubBannerData.webviewFlag ?? false,
        notificationPromptFlag: this.homeSubBannerData.notificationPromptFlag ?? false,
        checkStatus: this.homeSubBannerData.checkStatus ?? '',
        imageURL: this.homeSubBannerData.imageURL ?? '', // 旧画像URL
        newImageURL: this.homeSubBannerData.newImageURL ?? '', // 新画像URL
        iosContentsURL: encodeURI(this.homeSubBannerData.iosContentsURL.replace(/[\s\uFEFF\xA0]/g, '')) ?? '',
        androidContentsURL: encodeURI(this.homeSubBannerData.androidContentsURL.replace(/[\s\uFEFF\xA0]/g, '')) ?? '',
      };

      this.disabledButton = 'disabled';

      await this.postRequest('/home-sub-banner/add', formDataTmp).then(res => {
        if (res.status === 'success') {
          this.$router.push({ name: 'HomeSubBanner' });
        } else {
          if (res.message) {
            this.showErrorModal(res.message);
          } else {
            this.showErrorModal(messageContent.requireTry('小バナー作成'));
          }
        }
        this.disabledButton = null;
      });
    },
    handleUploadFileChange(key, fileList) {
      const fileObj = this.homeSubBannerData[key];
      const reader = new FileReader();
      reader.addEventListener(
        'load',
        function () {
          // eslint-disable-next-line no-unused-vars
          const [info, content] = reader.result.split(',');
          fileObj.binary = content;
        },
        false
      );
      if (fileList && fileList[0]) {
        reader.readAsDataURL(fileList[0]);
        fileObj.filename = fileList[0].name;
        fileObj.size = fileList[0].size;
      } else {
        // clear file content
        fileObj.file = null;
        fileObj.filename = null;
        fileObj.binary = null;
        fileObj.size = null;
        if (key === 'imageFile') {
          this.homeSubBannerData.imageURL = '';
        } else if (key === 'newImageFile') {
          this.homeSubBannerData.newImageURL = '';
        }
      }
    },
    handleChange() {},
    handleCancelClick() {
      this.$router.push({ name: 'HomeSubBanner' });
    },

    handleCloseModal() {
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
    },
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
    },
    showInfoModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.infoModalTitle;
      this.resultModalContent = message;
    },
  },
};
</script>
